import { render, staticRenderFns } from "./MobileTrueRating.vue?vue&type=template&id=035e1b6d&lang=pug"
import script from "./MobileTrueRating.vue?vue&type=script&lang=js"
export * from "./MobileTrueRating.vue?vue&type=script&lang=js"
import style0 from "./MobileTrueRating.vue?vue&type=style&index=0&id=035e1b6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports